import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO =
  "https://customer-assets-0z36b82j.emergentagent.net/job_web-forge-2354/artifacts/3681ae35dc49d13f_38913A32-E62B-45A1-A1AE-D8435497D960.png";

const LINKS = [
  { label: "The Sound", href: "#sound" },
  { label: "The Story", href: "#story" },
  { label: "Booking", href: "#booking" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const tapRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Single tap -> scroll to top. Double tap -> secret admin access.
  const handleLogo = (e) => {
    e.preventDefault();
    if (tapRef.current) {
      clearTimeout(tapRef.current);
      tapRef.current = null;
      navigate("/admin/login");
    } else {
      tapRef.current = setTimeout(() => {
        tapRef.current = null;
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 280);
    }
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "backdrop-blur-xl bg-zinc-950/80 border-b border-zinc-800" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-[72px] flex items-center justify-between">
        <a href="#top" onClick={handleLogo} className="flex items-center gap-3 group select-none cursor-pointer" data-testid="nav-logo" title="Mr Zee">
          <img
            src={LOGO}
            alt="Zee Nation"
            draggable="false"
            className="h-14 sm:h-16 w-auto object-contain mix-blend-lighten transition-transform duration-300 group-hover:scale-105"
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="font-mono text-xs uppercase tracking-[0.18em] text-zinc-400 hover:text-white transition-colors"
              data-testid={`nav-link-${l.href.slice(1)}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden backdrop-blur-xl bg-zinc-950/95 border-b border-zinc-800 px-4 py-6" data-testid="nav-mobile-menu">
          <nav className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-display text-3xl uppercase text-zinc-200 hover:text-rose-500 transition-colors"
                data-testid={`nav-mobile-link-${l.href.slice(1)}`}
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
